import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { IUpdateTheme, IUpdateThemeData, IUpdateThemeResponse, IUpdateThemeRequest, isValidResponse, IThemeUpdate } from "../types";
import { VIPER_CONST } from "../commonConstant";
import PublishreApi from "../api/publisher-api";
import { RootState } from "../app/store";

const initialState: IUpdateThemeRequest = {
  // live: null,
  preview: null,
  themebuilder: "",
  loading: false,
  error: null,
  data: undefined,
};

export const updateTheme = createAsyncThunk(
  "affiliate/updateTheme",
  async (request: IThemeUpdate, thunkApi) => {
    try {
      const response = await PublishreApi.UpdateApi(request);
      if (!isValidResponse(response)) {
        throw new Error("Invalid response format");
      }
      return response;
    } catch (error: any) {
      return thunkApi.rejectWithValue(error.message || "An error occurred");
    }
  }
);

const affiliateSlice = createSlice({
  name: "update affiliate",
  initialState,
  reducers: {
    clearAffiliate: (state) => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(updateTheme.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(updateTheme.fulfilled, (state, action: PayloadAction<IUpdateThemeResponse>) => {
      state.loading = false;
      state.data = action.payload;
    });
    builder.addCase(updateTheme.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
  },
});

export const { clearAffiliate } = affiliateSlice.actions;
export const themeLoading = (state: RootState) => state.updateTheme.loading;
export default affiliateSlice.reducer;
